export default {
  "title": "全球最权威的专家",
  "anchor": "expert",
  "items": [
    {
      "name": "Michael Jordan",
      "from": "加州大学伯克利分校",
      "position": "教授、美国科学院院士",
      "brief": "人工智能领域宗师级人物",
      "pic": "expert_01.jpg"
    },
    {
      "name": "Daniela Rus",
      "from": "MIT麻省理工学院",
      "position": "计算机科学与人工智能实验室主任",
      "brief": "全球人工智能领域最权威专家之一",
      "pic": "expert_02.jpg"
    },
    {
      "name": "杨培东",
      "from": "加州大学伯克利分校",
      "position": "美国科学院院士<br>化学和材料科学双聘教授",
      "brief": "世界顶级材料学家、人工光合作用领域的先锋",
      "pic": "expert_03.jpg"
    },
    {
      "name": "Yann LeCun",
      "from": "Facebook",
      "position": "人工智能研究部主管",
      "brief": "全球机器学习领域四大巨头之一",
      "pic": "expert_04.jpg"
    },
    {
      "name": "Joi Ito",
      "from": "MIT麻省理工学院",
      "position": "Media Lab 负责人",
      "brief": "MIT 黑科技实验室现任领导者",
      "pic": "expert_05.jpg"
    },
    {
      "name": "Robert J. Wood",
      "from": "加州大学伯克利分校",
      "position": "保尔森工程与应用科学学院教授",
      "brief": "开启了全球软体机器人新时代",
      "pic": "expert_06.jpg"
    },
    {
      "name": "李飞飞",
      "from": "斯坦福大学",
      "position": "人工智能和视觉实验室负责人",
      "from2": "Google",
      "position2": "Google Cloud 首席科学家",
      "brief": "机器视觉领域最具权威的专家",
      "pic": "expert_07.jpg"
    },
    {
      "name": "陈刚",
      "from": "MIT麻省理工学院",
      "position": "机械工程系系主任",
      "brief": "机械工程世界第一院系掌门人",
      "pic": "expert_08.jpg"
    },
    {
      "name": "Christopher Bishop",
      "from": "微软",
      "position": "剑桥实验室wet laboratory负责人",
      "brief": "微软全球顶级科学家",
      "pic": "expert_09.jpg"
    },
    {
      "name": "Stuart Russell",
      "from": "伯克利大学",
      "position": "计算机科学系教授<br>智能系统中心主任",
      "brief": "最权威的人工智能专著的作者",
      "pic": "expert_10.jpg"
    },
    {
      "name": "Dr. Michael S. Gazzaniga",
      "from": "美国加州大学圣巴巴拉分校",
      "position": "认知神经科学研究所负责人<br>美国科学院院士",
      "brief": "全球认知神经科学之父",
      "pic": "expert_11.jpg"
    },
    {
      "name": "薛其坤",
      "from": "清华大学/中科院",
      "position": "科研院院长<br>院士",
      "brief": "中国量子领域巨擘",
      "pic": "expert_12.jpg"
    },
  ]
}



// WEBPACK FOOTER //
// ./src/mock/expert.js